module.exports = "/images/jrmall-carousel-action.svg";